module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/kotahi-selects-linescape-sailing-schedules-api/kotahi-selects-linescape-sailing-schedules-api.scss
// module id = 889
// module chunks = 0